import { Cauldron, CauldronState } from "./cauldron/cauldron";
import { Item } from "./inventory/item";
import { Inventory } from "./inventory/inventory";
import { RecipeBook } from "./recipes/recipeBook";
import { delay, getOneByClass } from "./util";
import { sounds } from "./soundManager";

export enum WitchState {
    Neutral,
    Happy,
    Sad
};

export class GameManager {
    div: HTMLElement;
    recipeBook: RecipeBook;
    inventory: Inventory;
    cauldrons: Cauldron[] = [
        new Cauldron(),
        new Cauldron(),
        new Cauldron()
    ];
    money: number = 100;
    witchState: WitchState = WitchState.Neutral;
    won: boolean = false;

    createElement() {
        this.div = getOneByClass("game");

        // do we need like a cauldrons manager?
        const cauldronsDiv = getOneByClass("cauldrons", this.div);
        for (var cauldron of this.cauldrons){
            cauldron.createElement(cauldronsDiv);
        }

        this.inventory = new Inventory();
        this.inventory.createElement();

        this.recipeBook = new RecipeBook();
        this.recipeBook.createElement();

        getOneByClass("wallet").innerHTML = this.money.toString();
    }

    brew() {
        const recipe = this.recipeBook.currentPage;
        for (let cauldron of this.cauldrons) {
            if (!cauldron.recipe) {
                cauldron.brew(recipe);
                this.spendMoney(recipe.totalCost);
                return;
            }
        }
        sounds.play("thump");
    }

    addIngredient(item: Item) {
        this.recipeBook.currentPage.addIngredient(item.ingredient);
    }

    addMoney(income: number) {
        this.money = Math.max(this.money + income, 0);
        var wallet = getOneByClass("wallet");
        wallet.innerHTML = this.money.toString();
        this.recipeBook.updateTotal();
        this.bounce(getOneByClass("coin", getOneByClass("game-info")), 1.2);

        sounds.play("coins1");
    }

    spendMoney(spent: number) {
        this.money = Math.max(this.money - spent, 0);
        var wallet = getOneByClass("wallet");
        wallet.innerHTML = this.money.toString();
        this.recipeBook.updateTotal();
        this.bounce(getOneByClass("coin", getOneByClass("game-info")), 1.2);
    }

    determineWitchExpression(newState: CauldronState) {
        if (newState == CauldronState.complete) {
            var failedCauldrons = this.cauldrons.find(c => c.state === CauldronState.failed);
            if (!failedCauldrons) {
                this.updateWitch(WitchState.Happy);
            }
        }
        else if (newState == CauldronState.failed) {
            this.updateWitch(WitchState.Sad);
        }
        else if (newState == CauldronState.brewing) {
            this.updateWitch(WitchState.Neutral);
        }
        else if (newState == CauldronState.empty) {
            var waitingCauldrons = this.cauldrons.find(c => c.state === CauldronState.complete || c.state === CauldronState.failed);
            var winning = !this.won && this.recipeBook?.pages.every(r => r.isMastered);
            if (!waitingCauldrons && !winning) {
                this.updateWitch(WitchState.Neutral);
            }
        }
    }

    async updateWitch(state: WitchState) {
        if (state != this.witchState) {
            this.witchState = state;
            var witch = getOneByClass("witch", this.div) as HTMLImageElement;

            switch (state) {
                case WitchState.Happy:
                    witch.src = "assets/witch/happy.png";
                    break;
                case WitchState.Sad:
                    witch.src = "assets/witch/sad.png";
                    break;
                default:
                    witch.src = "assets/witch/busy.png";
                    break;
            }

            this.bounce(witch);
        }
    }

    async bounce(elem, scale = 1.02) {
        elem.style.transform = `scale(${scale})`;
        await delay(200);
        elem.style.transform = "scale(1)";
    }

    async checkForWin() {
        if (!this.won && this.recipeBook.pages.every(r => r.isMastered)) {
            await delay(10); // otherwise the click goes through

            this.won = true;
            const wrapper = getOneByClass("game-wrapper");
            const popup = getOneByClass("popup");
            popup.style.display = "block";
            sounds.play("win");

            wrapper.onclick = () => {
                popup.style.display = "none";
                wrapper.onclick = null;
            }
        }
    }
}

export const game = new GameManager();